import { BASEURL } from '../Constants';

const getToken = () => sessionStorage.getItem('token');

const unwrapList = (data, key) => {
  if (!data || typeof data !== 'object') return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data[key])) return data[key];
  if (Array.isArray(data.data)) return data.data;
  return [];
};

async function request(path, options = {}) {
  const response = await fetch(`${BASEURL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
  });

  if (response.status === 204) return null;

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error) {
    throw new Error(data?.message || 'Copilot skills request failed.');
  }
  return data;
}

export const copilotSkillsApi = {
  async listSkills() {
    const data = await request('/copilot/skills');
    return unwrapList(data, 'skills');
  },

  async getSystemSkill(slug) {
    const data = await request(`/copilot/skills/system/${encodeURIComponent(slug)}`);
    return data.skill || data;
  },

  async getCustomSkill(skillId) {
    const data = await request(`/copilot/skills/custom/${encodeURIComponent(skillId)}`);
    return data.skill || data;
  },

  async createCustomSkill(payload) {
    const data = await request('/copilot/skills/custom', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.skill || data;
  },

  async updateCustomSkill(skillId, payload) {
    const data = await request(`/copilot/skills/custom/${encodeURIComponent(skillId)}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return data.skill || data;
  },

  async deleteCustomSkill(skillId) {
    return request(`/copilot/skills/custom/${encodeURIComponent(skillId)}`, {
      method: 'DELETE',
    });
  },

  async listSessionSkills(sessionId) {
    const data = await request(`/copilot/sessions/${encodeURIComponent(sessionId)}/skills`);
    return unwrapList(data, 'skills');
  },

  async assignSessionSkill(sessionId, payload) {
    const data = await request(`/copilot/sessions/${encodeURIComponent(sessionId)}/skills`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.skill || data.assignment || data;
  },

  async removeSessionSkill(sessionId, assignmentId) {
    return request(`/copilot/sessions/${encodeURIComponent(sessionId)}/skills/${encodeURIComponent(assignmentId)}`, {
      method: 'DELETE',
    });
  },
};
